import { IReportCustomFieledConfig } from "@shared/lib/types/reports";
import { Eye, EyeOff, Loader2, Plus } from "lucide-react";
import styles from "../styles.module.scss";

type ReportCustomFieldsViewProps = {
  fields: IReportCustomFieledConfig[];
  onCreateClick: () => void;
  onToggleVisibility: (field: IReportCustomFieledConfig) => void;
  getFieldVisibility: (field: IReportCustomFieledConfig) => boolean;
  isToggling: boolean;
};

export function ReportCustomFieldsView({
  fields,
  onCreateClick,
  onToggleVisibility,
  getFieldVisibility,
  isToggling,
}: ReportCustomFieldsViewProps) {
  const reversedFields = [...fields].reverse();

  return (
    <div className={styles.viewContainer}>
      <button
        type="button"
        onClick={onCreateClick}
        className={styles.createButton}
      >
        <Plus size={16} /> Create New Field
      </button>

      <div className={styles.fieldsList}>
        {fields.length === 0 ? (
          <div className={styles.emptyState}>No custom fields yet.</div>
        ) : (
          reversedFields.map((field) => {
            const isVisible = getFieldVisibility(field);
            return (
              <div key={field._id || field.key} className={styles.fieldItem}>
                <div className={styles.fieldInfoStatic}>
                  <div className={styles.fieldName}>
                    {field.displayName || field.key}
                  </div>
                  <div className={styles.fieldMeta}>
                    <span className={styles.fieldType}>
                      {field.type || "string"}
                    </span>
                    {field.description && (
                      <span className={styles.fieldDefault}>
                        • {field.description}
                      </span>
                    )}
                    {field.defaultValue !== undefined &&
                      field.defaultValue !== "" && (
                        <span className={styles.fieldDefault}>
                          • Default: {String(field.defaultValue)}
                        </span>
                      )}
                  </div>
                </div>
                <div className={styles.fieldActions}>
                  <button
                    type="button"
                    onClick={() => onToggleVisibility(field)}
                    disabled={isToggling}
                    className={`${styles.visibilityButton} ${
                      isVisible ? styles.visibilityButtonActive : ""
                    }`}
                    title={isVisible ? "Visible" : "Hidden"}
                  >
                    {isToggling ? (
                      <Loader2 size={14} className={styles.spinner} />
                    ) : isVisible ? (
                      <Eye size={14} />
                    ) : (
                      <EyeOff size={14} />
                    )}
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
